export default __webpack_public_path__ + "static/media/lecteur-oneloop-3-silla.703e13d5.gif";